export const MM_DD_YY = "MM/DD/YY";

export const WHITESPACE_MMMM_YYYY = "MMMM YYYY";

export const COMMA_MMM_D_YYYY = "MMM D, YYYY";
